import Preguntas from './Preguntas';
export default Preguntas;
